import { Disclosure } from '@headlessui/react'
import type { FunctionComponent, ReactNode } from 'react'
import 'twin.macro'
import { GridWithGaps } from '../layout/MainGrid'
import type { WidgetType } from './AccordionStyledComponents'
import {
  PaddingContainer,
  StyledPanelContent,
} from './AccordionStyledComponents'
import { ArrowAccordionDisclosureButton } from './ArrowAccordionDisclosureButton'
import { DisclosureButton } from './DisclosureButton'
import { ExpandableBlockDisclosureButton } from './ExpandableBlockDisclosureButton'

export type SimpleAccordionEntryProps = {
  title: string
  titleWhenExpanded?: string
  clickHandler?: (index: number, action: boolean) => void
  index?: number
  useAqua?: boolean
  smallSize?: boolean
  widgetType?: WidgetType
  className?: string
  noMarginTop?: boolean
  children: ReactNode
}

const DisclosurePanel: FunctionComponent<React.PropsWithChildren<{
  smallSize: boolean
  open: boolean
  widgetType?: WidgetType
  noMarginTop?: boolean
}>> = ({ smallSize, open, children, widgetType, noMarginTop }) => {
  return (
    <>
      <Disclosure.Panel static>
        <GridWithGaps>
          <StyledPanelContent
            widgetType={widgetType}
            open={open}
            smallSize={smallSize}
            noMarginTop={noMarginTop}
          >
            {children}
          </StyledPanelContent>
        </GridWithGaps>
      </Disclosure.Panel>
    </>
  )
}

export const SimpleAccordionEntry: FunctionComponent<React.PropsWithChildren<SimpleAccordionEntryProps>> = ({
  title,
  titleWhenExpanded,
  clickHandler,
  useAqua,
  smallSize,
  widgetType,
  index,
  children,
  className,
  noMarginTop,
}) => {
  return (
    <PaddingContainer smallSize={smallSize}>
      <Disclosure>
        {({ open }) => (
          <>
            {(!widgetType || widgetType === 'DefaultAccordion') && (
              <>
                <dt>
                  <DisclosureButton
                    title={title}
                    titleWhenExpanded={titleWhenExpanded}
                    open={open}
                    useAqua={useAqua}
                    smallSize={smallSize}
                    className={className}
                    clickHandler={() =>
                      clickHandler && index ? clickHandler(index, open) : null
                    }
                  />
                </dt>
                <DisclosurePanel open={open} smallSize={!!smallSize}>
                  {children}
                </DisclosurePanel>
              </>
            )}
            {widgetType === 'ExpandableBlock' && (
              <>
                <DisclosurePanel open={open} smallSize={!!smallSize}>
                  {children}
                </DisclosurePanel>
                <ExpandableBlockDisclosureButton
                  title={title}
                  titleWhenExpanded={titleWhenExpanded}
                  open={open}
                  useAqua={useAqua}
                  smallSize={smallSize}
                  clickHandler={() =>
                    clickHandler && index ? clickHandler(index, open) : null
                  }
                />
              </>
            )}
            {widgetType === 'ArrowAccordion' && (
              <>
                <ArrowAccordionDisclosureButton
                  title={title}
                  titleWhenExpanded={titleWhenExpanded}
                  open={open}
                  useAqua={useAqua}
                  smallSize={smallSize}
                  clickHandler={() =>
                    clickHandler && index ? clickHandler(index, open) : null
                  }
                />
                <DisclosurePanel
                  widgetType="ArrowAccordion"
                  open={open}
                  smallSize={!!smallSize}
                  noMarginTop={noMarginTop}
                >
                  {children}
                </DisclosurePanel>
              </>
            )}
          </>
        )}
      </Disclosure>
    </PaddingContainer>
  )
}
